import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../contexts/AuthContext';
import { notificationsAPI } from '../../services/api';

const NAV = [
  { group: 'الرئيسية',    items: [{ to:'/',          icon:'🏠', label:'لوحة التحكم' }] },
  { group: 'التواصل',     items: [
    { to:'/chat',        icon:'💬', label:'المراسلات الفردية' },
    { to:'/groups-chat', icon:'👥', label:'المراسلات الجماعية' },
    { to:'/groups',      icon:'🗂',  label:'إدارة المجموعات' },
    { to:'/video',       icon:'📹', label:'الاجتماعات المرئية' },
  ]},
  { group: 'الوثائق',     items: [
    { to:'/files',       icon:'📁', label:'إرسال واستقبال الملفات' },
    { to:'/archive',     icon:'🗄',  label:'أرشيف الملفات' },
  ]},
  { group: 'الإدارة الرسمية', items: [
    { to:'/circulars',   icon:'📢', label:'التعاميم والإشعارات' },
    { to:'/decisions',   icon:'🖊',  label:'القرارات والتوقيع' },
    { to:'/calendar',    icon:'📅', label:'التقويم والجدولة' },
  ]},
  { group: 'التحليل',     items: [
    { to:'/kpi',         icon:'📊', label:'مؤشرات الأداء KPI' },
    { to:'/reports',     icon:'📋', label:'التقارير والإحصاءات' },
    { to:'/ai',          icon:'🤖', label:'مساعد الذكاء الاصطناعي' },
  ]},
  { group: 'النظام',      items: [
    { to:'/users',       icon:'🔐', label:'المستخدمون والصلاحيات' },
    { to:'/log',         icon:'🕐', label:'سجل النشاطات' },
    { to:'/security',    icon:'🛡',  label:'الأمان والنسخ الاحتياطي' },
  ]},
];

const PAGE_TITLES = {
  '/':            { t:'لوحة التحكم',                    s:'نظرة شاملة على النظام' },
  '/chat':        { t:'المراسلات الفردية',               s:'تواصل مباشر · آمن ومشفر' },
  '/groups-chat': { t:'المراسلات الجماعية',              s:'مجموعات العمل' },
  '/groups':      { t:'إدارة المجموعات',                 s:'إنشاء وإدارة مجموعات العمل' },
  '/video':       { t:'الاجتماعات المرئية',              s:'HD · تسجيل · مشاركة شاشة' },
  '/files':       { t:'إرسال واستقبال الملفات',          s:'مشاركة آمنة · تتبع الملفات' },
  '/archive':     { t:'أرشيف الملفات',                  s:'بحث OCR · تصنيف ذكي' },
  '/circulars':   { t:'التعاميم والإشعارات',             s:'إصدار وتتبع التعاميم' },
  '/decisions':   { t:'القرارات والتوقيع الإلكتروني',    s:'قرارات رسمية · توقيع رقمي موثّق' },
  '/calendar':    { t:'التقويم وجدولة الاجتماعات',       s:'مواعيد · دعوات تلقائية' },
  '/kpi':         { t:'لوحة مؤشرات الأداء KPI',          s:'إحصائيات التواصل' },
  '/reports':     { t:'التقارير والإحصاءات',             s:'تقارير إدارية وتشغيلية' },
  '/ai':          { t:'مساعد الذكاء الاصطناعي',          s:'كتابة · تلخيص · تحليل · بحث' },
  '/users':       { t:'المستخدمون والصلاحيات',           s:'إدارة الحسابات والأدوار' },
  '/log':         { t:'سجل النشاطات',                   s:'تتبع كامل لجميع العمليات' },
  '/security':    { t:'الأمان والنسخ الاحتياطي',         s:'حماية البيانات · تشفير' },
};

export default function Layout() {
  const { user, logout }  = useAuth();
  const navigate          = useNavigate();
  const location          = useLocation();
  const [notifs, setNotifs] = useState([]);
  const [npOpen, setNpOpen] = useState(false);

  useEffect(() => {
    notificationsAPI.list().then(r => setNotifs(r.data)).catch(()=>{});
  }, [location]);

  const doLogout = async () => {
    await logout();
    toast.info('تم تسجيل الخروج');
    navigate('/login');
  };

  const page = PAGE_TITLES[location.pathname] || { t:'SPORTIX-MATRIX', s:'' };
  const unreadNotifs = notifs.filter(n => !n.is_read).length;

  return (
    <div className="app-layout">
      {/* ── SIDEBAR ── */}
      <aside className="sidebar">
        <div className="sb-logo-box">
          <div className="sb-logo">
            <div className="sb-icon">⚽</div>
            <div>
              <div className="sb-title">SPORTIX – MATRIX</div>
              <div className="sb-version">Sports Management Platform v4</div>
            </div>
          </div>
          {user && (
            <div className="sb-user">
              <div className="avatar" style={{width:30,height:30,fontSize:10,background:user.avatar_color||'#C9952A',color:'#fff'}}>{user.initials}</div>
              <div><div className="sb-uname">{user.full_name}</div><div className="sb-urole">{user.job_title||user.role}</div></div>
              <div style={{marginRight:'auto'}}><div className="online-dot"/></div>
            </div>
          )}
        </div>
        <div className="sb-search"><input placeholder="🔍 بحث سريع..." /></div>
        <nav className="sb-nav">
          {NAV.map(section => (
            <div key={section.group}>
              <div className="nav-group">{section.group}</div>
              {section.items.map(item => (
                <NavLink key={item.to} to={item.to} end={item.to==='/'} className={({isActive})=>`nav-item${isActive?' active':''}`}>
                  <div className="nav-item-ic">{item.icon}</div>
                  <span className="nav-item-label">{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div style={{padding:'8px 14px',borderTop:'1px solid rgba(255,255,255,.04)'}}>
          <div style={{display:'flex',alignItems:'center',gap:6,color:'rgba(168,180,192,.4)',fontSize:9}}>
            <div className="online-dot"/>SPORTIX-MATRIX © {new Date().getFullYear()} · sportix.ae
          </div>
        </div>
      </aside>

      {/* ── MAIN ── */}
      <div className="main-area">
        <header className="topbar" style={{position:'relative'}}>
          <div>
            <div className="topbar-title">{page.t}</div>
            <div className="topbar-sub">{page.s}</div>
          </div>
          <div className="topbar-right">
            <div className="icon-btn" title="بحث">🔍</div>
            <div className="icon-btn" title="الإشعارات" onClick={() => setNpOpen(o=>!o)}>
              🔔{unreadNotifs > 0 && <span className="notif-dot"/>}
            </div>
            <div className="icon-btn" title="طباعة" onClick={() => window.print()}>🖨️</div>
            <div className="icon-btn" title="الإعدادات">⚙️</div>
            {user && (
              <div className="avatar" style={{width:30,height:30,fontSize:10,background:user.avatar_color||'#C9952A',color:'#fff',cursor:'pointer'}} onClick={doLogout} title="تسجيل الخروج">
                {user.initials}
              </div>
            )}
          </div>
          {npOpen && (
            <div style={{position:'absolute',top:62,left:4,width:290,background:'var(--wh)',border:'1px solid var(--b1)',borderRadius:'var(--r2)',boxShadow:'var(--sh2)',zIndex:500,maxHeight:'72vh',overflowY:'auto'}}>
              <div style={{padding:'10px 13px',borderBottom:'1px solid var(--b1)',fontSize:11,fontWeight:800,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                🔔 الإشعارات
                <span style={{fontSize:9,color:'var(--gd)',cursor:'pointer'}} onClick={()=>notificationsAPI.readAll().then(()=>setNotifs(ns=>ns.map(n=>({...n,is_read:1}))))}>تعيين كمقروء</span>
              </div>
              {notifs.slice(0,8).map(n => (
                <div key={n.id} style={{padding:'9px 12px',borderBottom:'1px solid var(--b1)',display:'flex',gap:8,cursor:'pointer',background:n.is_read?'transparent':'var(--inb)'}}>
                  <div style={{fontSize:9,flex:1}}><div style={{fontWeight:700,fontSize:10.5}}>{n.title}</div><div style={{color:'var(--t3)',fontSize:8.5}}>{new Date(n.created_at).toLocaleString('ar')}</div></div>
                </div>
              ))}
              {!notifs.length && <div style={{padding:14,textAlign:'center',fontSize:10,color:'var(--t3)'}}>لا توجد إشعارات</div>}
            </div>
          )}
        </header>
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
